export default class Note {
  constructor() {
    this.content = ''
    this.title = ''
    this.user_id = ''
    this.active = false
    this.created_at = ''
  }
}
